import * as Yup from "yup";

export const tenantFormValidationSchema = Yup.object({
  name: Yup.string()
    .required("Company name is required")
    .max(200, "Company name cannot exceed 200 characters"),
  contactEmail: Yup.string()
    .email("Enter a valid email address")
    .max(255, "Email cannot exceed 255 characters")
    .nullable(),
  contactPhone: Yup.string()
    .max(50, "Phone number cannot exceed 50 characters")
    .nullable(),
  safetyEmail: Yup.string()
    .email("Enter a valid email address")
    .max(255, "Email cannot exceed 255 characters")
    .nullable(),
  isActive: Yup.boolean().required(),
});

export interface TenantFormValues {
  name: string;
  contactEmail: string;
  contactPhone: string;
  safetyEmail: string;
  isActive: boolean;
}

export const getInitialTenantFormValues = (): TenantFormValues => ({
  name: "",
  contactEmail: "",
  contactPhone: "",
  safetyEmail: "",
  isActive: true,
});
